export const REDUX_CHANGE = '@@redux-form/CHANGE';
export const REDUX_BLUR = '@@redux-form/BLUR';
export const LOAD_DOCUMENT_SUCCESS = '@empresas/loadDocumentSuccess';
export const LOAD_CATALOG_SUCCESS = '@empresas/loadCatalogSuccess';
export const LOAD_CATALOG = '@empresas/loadCatalog';
export const INCREASE_STEP = '@empresas/increaseStep';
export const FORM_NAME_STEP_PRINCIPAL = 'stepPrincipal';
export const FORM_NAME_STEP0 = 'informacionInicioInscripcion';
export const FORM_NAME_STEP1 = 'informacionPersonal';
export const FORM_NAME_STEP2 = 'informacionEmpleador';
export const FORM_NAME_STEP3 = 'ubicacionEmpleador';
export const FORM_NAME_STEP4 = 'informacionRepresentante';
export const FORM_NAME_STEP5 = 'anexosDocumentos';
export const FORM_NAME_STEP6 = 'juramentoStep6';
export const FORM_NAME_DIRECCION = 'crearDireccion';
export const FORM_NAME_NUM_PROCESS = 'validarProceso';
export const UPDATE_FIELD_ATTRIBUTE = '@empresas/updateAttribute';
export const SALVAR_STEP = '@empresas/salvarStep';
export const DECREASE_STEP = '@empresas/decreaseStep';
export const HANDLE_STEP = '@empresas/handleStep';
export const OPEN_FINAL_MODAL = '@empresas/openFinalModal';
export const ARCHIVOS_ADJUNTOS = 'Documentos anexos'
export const BASE64_REMOVE = '@empresas/base64Remove';
export const CONTACTO_ADD = '@empresas/contactoAdd';
export const INCREASE_SIGUIENTE = '@empresas/increaseSiguiente';
export const LIMITE_STEP = '@empresas/limitStep';
export const INIT_CATALOG_COMPLETED = '@empresas/initCatalogCompleted';
export const SAVE_PERSONAL_ADMIN = '@empresas/savePersonalAdmin';
export const SAVE_ANEXOS_FROM_DEVOL = '@empresas/saveAnexosFromDevol';
export const VALID_RNEC_REP_LEGAL = '@empresas/validRnecRepLegal';
export const INIT_EDITAR_FROM_BANDEJA = '@empresas/initEditarFromBandeja';
export const GESTIONA_MODAL_TRY_CATCH = '@empresas/gestionAModalTryCatch';

export const AFILIACION_EMPRESAS_TITLE = 'Formulario de afiliación de empleador por primera vez';
export const DATOS_INICIO_TITLE = 'Registro';
export const DATOS_EMPLEADOR_TITLE = 'Información del empleador';
export const UBICACION_EMPLEADOR_TITLE = 'Ubicación del empleador';
export const UBICACION_EMPLEADOR_TITLE_ALTERN = 'Ubicación alterna del empleador';
export const DATOS_REPRESENTANTE_TITLE = 'Información representante legal';
export const DATOS_PERSONAL_TITLE = 'Información personal administrativo y/o directivo';
export const CHARGE_ANEXOS_STORAGE = '@empresas/chargeAnexosStorage'
export const STEPS_CONTENT = ['Registro', 'Datos de Contacto', 'Información del Empleador', 'Datos de Ubicación', 'Representante Legal', 'Anexos'];
export const STEPS_CONTENT_DOMESTICO = ['Registro', 'Información del empleador', 'Datos de ubicación', 'Representante legal', 'Anexos'];


//________________________________________________________________

export const ACTIVE_FORM_RYA = '@empresas/activeFormRya';
export const EXPORT_BASE64_UNIQUE = '@empresas/exportBase64Unique'
export const TITTLE_ENCABEZADO = 'Afiliación Empleadores';
export const SUBTITTLE_ENCABEZADO = 'Caja de compensación Comfenalco Valle Delagente';
export const CLOSE_MODAL_DIRECCION = '@empresas/closeModalDireccion';
export const CREATE_DIRECCION_MODAL = '@empresas/createDireccionModal';
export const OPEN_MODAL_DIRECCION = '@empresas/openModalDireccion';
export const VALIDA_AFILIACION_COMPANY = '@empresas/validaAfiliacionCompany';
export const ESTADO_AFILIACION_COMPANY = '@empresas/estadoAfiliacionCompany';
export const SAVED_CATALOG_COMPANY = '@empresas/savedCatalogCompany';
export const FORMULARIO_OF_COMERCIAL = '@empresas/formularioOfComercial';

export const GESTION_PERSONAL_ADMIN = '@empresas/gestionPersonalAdmin';
export const CLEAN_PERSONAL_ADMIN = '@empresas/cleanPersonalAdmin';
export const DELETE_PERSONAL_ADMIN = '@empresas/deletePersonalAdmin';
export const NUMBER_FORMULARIO_FIREBASE = '@empresas/numberFormularioFirebase';
export const IDUSER_FORMULARIO_FIREBASE = '@empresas/iduserFormularioFirebase';
export const MODAL_INFORMACION_FLUJOS = '@empresas/modalInformacionFlujos';
export const CLOSE_MODAL_FLUJOS = '@empresas/closeModalFlujos';
export const CLOSE_MODAL_FINAL = '@empresas/closeModalFinal';
export const OPEN_MODAL_ACCEPT_PDF = '@empresas/openModalAcceptPDF';
export const CLOSE_MODAL_ACEPT_PDF = '@empresas/closeModalAcceptPDF';
export const CHANGE_COMPONENT_ID = '@empresas/changeComponentId';
export const DELETE_CONTACTO_FROM_VALID_STEP4 = '@empresas/deleteContactsFromValidationStep4';
export const DELETE_CONTACTO_EXISTS_STEP4 = '@empresas/deleteContactExistsStep4';

export const SAVE_DATA_TABLE_PERSONAL = '@empresas/saveDataTablePersonal';
export const OPEN_MODAL_CHARGED = '@empresas/openModalCharged';
export const SAVED_EMPLEADOR_TYPE = '@empresas/savedEmpleadorType';

export const UPLOAD_ANEXOS = '@empresas/uploadAnexos';
export const REMOVE_ANEXOS = '@empresas/removeAnexos';
export const DELETE_ANEXOS = '@empresas/deleteAnexos';
export const SEE_ANEXOS = '@empresas/seeAnexos';
export const SAVE_ANEXOS = '@empresas/saveAnexos';
export const POPUP_SEE_ANEXOS = '@empresas/popupSEEAnexos';
export const CLOSED_POPUP_ADJUNTOS = '@empresas/closeModalAdjuntos';
export const SAVED_SOLICITUDES = '@empresas/savedSolicitudes';

export const CLOSE_MODAL_NUM_PROCESS = '@empresas/closeModalNumProcess';
export const VALIDATE_NUM_PROCESS = '@empresas/validateNumProcess';
export const OPEN_MODAL_NUM_PROCESS = '@empresas/openModalNumProcess';
export const SAVE_REFE_FILES = '@empresas/saveRefeFiles';
export const DATA_PANTALLA_INICIO = '@empresas/dataPantallaInicio';
export const FORMULARIO_TYPE = '@empresas/formularioType';
export const CALL_DINAMIC_DISABLE = '@empresas/callDinamicDisable';
export const CALL_DINAMIC_DISABLE_LOTE = '@empresas/callDinamicDisableLote';
export const OPEN_MODAL_FINAL_FORM = '@empresas/openModalFinalForm';
export const CLOSE_MODAL_FINAL_FORM = '@empresas/closeModalFinalForm';
export const SAVE_REFERENCE_BARCODE = '@empresas/saveReferenceBarcode';
export const INFO_USER_COMERCIAL = '@empresas/infoUserComercial';
export const CLEAN_AUTO_COMPLETE = '@empresas/cleanAutoComplete';
export const OPEN_VALIDATE_ANEXOS = '@empresas/openValidateAnexos';
export const CHANGE_CORREGIMIENTO_FORM = '@empresas/changeCorregimientoForm';
export const OPEN_MODAL_FORMULARIO_REG = '@empresas/openModalFormularioRegistro';
export const UNLOCK_PERSONA_NATURAL = '@empresas/unlockPersonaNatural';
export const DEVUELTA_MODIFICACION_ACTIVE = '@empresas/devueltaModificacionActive';
export const SAVED_TAMANIO_FILES = '@empresas/savedTamanioFiles';
export const SAVED_ID_APP = '@empresas/savedIdApp';
export const VALIDATE_ERRORS_FORMAT = '@empresas/validateErrorsForm';
export const UPLOAD_ANEXOS_FROM_SAGA = '@empresas/uploadAnexosSaga';
export const SAVE_USER_COMERCIAL = '@empresas/saveUserComercial';
export const VEFICATED_CHANGES_FROM_BANDEJA = '@empresas/verficatedChagesFromBandeja';
export const CHANGES_FROM_BANDEJA = '@empresas/chagesFromBandeja';
export const RETURN_TO_HOME = '@empresas/returnToHome';
export const OPEN_MODAL_RETURN_HOME = '@empresas/openModalReturnHome';
export const CLOSE_MODAL_RETURN_HOME = '@empresas/closeModalReturnHome';
export const VER_MOTIVO_DEVOLUCION = '@empresas/verMotivoDevolucion';
export const CREATE_USUARIO_PERSONA = '@empresas/createUserPerson';
export const SAVE_SOLICITUDES_SIN_FIRMA = '@empresas/saveSolicitudesSinFirma';
export const ERROR_GENERAL = '@empresas/errorGeneral';
export const UPDATE_MSG_SOLICITUD = '@empresas/updateMsgSolicitud';
export const EDITING_ENABLED_CONTACT = '@empresas/editingEnabledContact';
export const SAVE_DATOS_CEDULAS_RNEC = '@empresas/saveDatosCedulasRnec';
export const DOWNLOAD_RELATION_WORKERS = '@empresas/downloadRelationWorkers';
export const ACTIVATE_SOPORT_RNEC = '@empresas/activateSoportRnec';
export const CLOSE_DIRECCION_MODAL_SUCCESS = '@empresas/closeDireccionModalSuccess';
export const SAVE_MAPEO_RUES_SUCCESS = '@empresas/saveMapeoRuesSuccess';

//________________________________________________________________

export const BODY_TERMINOS_P1 = `Los datos personales que se recolecten a través de la aplicación Web para tramitar la afiliación a la Caja de Compensación Familiar en cumplimiento a la Ley 21 de 1981 y demás normas complementarias, se realiza por estipulación a favor de otro o para otro, de conformidad a lo dispuesto por el numeral 4 del artículo 2.2.2.25.4.1 del Decreto 1074 de 2015, reglamentario de la Ley 1581 de 2012, Régimen General de Protección de Datos Personales y se tratarán conforme las finalidades consignadas en la Política de Tratamiento de la Información publicada en la página web www.comfenalcovalle.com.co.`;
export const BODY_TERMINOS_P2 = `Declaro que la información que he condensado en el presente formulario es veraz, autorizo a Comfenalco Valle Delagente a que verifique la información en cualquier momento y a deducir de mi subsidio familiar en dinero los valores que me hayan dispuesto sin tener derecho a él, por este concepto o por el reporte inoportuno de las novedades.`


export const JURAMENTO_TITLE = 'Juramento de cumplimiento de requisitos para postulación a subsidio de empresas'
export const ARCHIVOS_ADJUNTOS_SUB_TITLE = 'Documentos que se deben anexar a esta postulación'

export const HEADERS_WS = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    'Access-Control-Allow-Credentials': 'true',
    "Access-Control-Request-Headers": "access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,auth,authorization,cache-control,content-type,mode",
    'accept': "application/json, text/plain, */*",
    "content-type": "application/json",
    "Cache-Control": "no-cache",
    'mode': "opaque ",
    "Authorization": 'Basic Rk9STVVMQVJJT1NXRUI6WWsyMTkwX3c=',
}

export const DISABLED_GENERICOS = {


}



export const MESSAGES_ALERT_PARAMETRIZADOS = [
    { value: "msgSolicitudEnProceso", download: false, label: "Hemos encontrado una solicitud de afiliación con los datos ingresados la cual se encuentra en proceso de validación por el área correspondiente. Si su proceso de afiliación lleva más de 1 día hábil por favor comuníquese a la línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgNumeroCCErrado", download: false, label: "El número de documento ingresado no arroja resultados o esta errado, por favor verifique la información e inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgSerAniNoDisponible", download: false, label: "El servicio de validación de información de la registraría nacional no se encuentra disponible, por favor ingrese la información como aparece en su documento de identificación personal. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgSerAniNoDisponibleWrite", download: false, label: "El servicio de validación de información de la registraría nacional no se encuentra disponible, por favor ingrese la información como aparece en su documento de identificación personal. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgEmpresaRegistradaSirapInactiva", download: false, label: "La informaciòn ingresada nos arroja que la empresa ya se encuentra registrada en nuestra base de datos y se encuentra en estado inactivo. Por favor comuníquese con nuestra línea de servicio al cliente 602 8862727 opción 2.El servicio de validación de información de la registraría nacional no se encuentra disponible, por favor ingrese la información como aparece en su documento de identificación personal. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgEmpresaRegistradaSirapActiva", download: false, label: "La información ingresada nos arroja que la empresa ya tiene un registro en nuestra base de datos. Por favor comuníquese con nuestra línea de servicio al cliente 602 8862727 opción 2." },
    { value: "msgValidaAniSuccess", download: false, label: "Sus datos de identificación fueron validados por medio de la Registraduria Nacional." },
    { value: "msgValidaAniSuccessRues", download: false, label: "Sus datos de identificación fueron validados por medio de Registro Unico Empresarial y Social - y por Registraduria Nacional." },
    { value: "msgMaximoRegistraContactos", download: false, label: "El máximo de personas que se pueden registrar con 3, si deseas agregar a alguien diferente debes eliminar uno de la lista." },
    { value: "msgAnexoDuplicadoMismaInfo", download: false, label: "Hemos encontrado en la solicitud un anexo que contiene la misma información que el archivo que intenta adjuntar. Por favor verifique la información e inténtenlo nuevamente." },
    { value: "msgAnexoNoCumpleCondiciones", download: false, label: "El archivo que intenta adjuntar no cumple con las condiciones permitidas para esta afiliación." },
    { value: "msgOportunidadIncorrectoOpenForm", download: false, label: "El valor ingresado no coincide con el que tiene registrado, por favor verifique la información e intentelo nuevamente." },
    { value: "msgConsultaEmpresasNoDisponible", download: false, label: "La operación solicitada no pudo completarse, intentalo nuevamente en unos segundos." },
    { value: "msgGeneralServicioNoDisponible", download: false, label: "Ocurrió una respuesta inesperada al momento de registrar su información, por favor inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2." },
    { value: "msgPdfAdobeSuccesReenvio", download: false, label: "El registro de su empresa ha terminado exitosamente y será evaluado por el área correspondiente. Si la documentación es aprobada, en el siguiente día hábil (1) quedará afiliado(a), de lo contrario le informaremos a su correo electrónico." },
    { value: "msgPdfAdobeFirmaSucces", download: false, label: "El registro de su empresa ha terminado exitosamente. Hemos enviado a su correo electrónico el formulario de afiliación para su firma electrónica. Una vez sea firmado el documento y aprobado por el área correspondiente, en el siguiente día hábil (1) su empresa quedará activa y podrá realizar la afiliación de sus colaboradores, de lo contrario recibirá una notificación." },

]

export const ENABLED_FROM_BANDEJA = [
    "birthDate",
    "firstLastname",
    "secondLastname",
    "firstName",
    "secondName",
    "sexo",
]

export const ENABLED_FROM_BANDEJA_STATIC = [
    "employedNumber",
    "payrollMonth",
    "startOperation",
    "firstLastnameStaff",
    "secondLastnameStaff",
    "firstNameStaff",
    "secondNameStaff",
    "birthDateStaff",
    "sexoStaff",
    "employerNameStart",
    "contributionPeriod",
    "economicActivityStart"
]

export const REQUIRED_FORM_PRINCIPAL = [
    { value: "empleadorTypeCompany", label: "Tipo de empleador" },
    { value: "typeIdCompanyGes", label: "Tipo de identificación" },
    { value: "numberIdCompanyGes", label: "Número de identificación" },
]

export const REQUIRED_DATOS_DIRECCION = [
    { value: "interseptionType", label: "Nombre de vía" },
    { value: "interseptionNumber", label: "# via" },
    { value: "interseptionNumberTwo", label: "via" },
    { value: "interseptionNumberThree", label: "via" },
]

export const REQUIRED_FORM_STEP0 = [
    { value: "employerNameStart", label: "Nombre del empleador" },
    { value: "typeIdCompanyStart", label: "Tipo de identificación" },
    { value: "checkNumberStart", label: "Número de identificación" },
    { value: "sedeRegional", label: "Regional" },
    { value: "emailCompanyStart", label: "Correo electrónico" },
    { value: "emailCompanyCheckStart", label: "Confirma Correo electrónico" },
    { value: "employedNumberStart", label: "Número de empleados" },
    { value: "economicActivityStart", label: "Actividad económica" },
    { value: "smartPhoneRegistro", label: "Número de celular" },
    { value: "payrollMonthStart", label: "Valor nómina mes" },
]

export const REQUIRED_FORM_STEP2 = [
    { value: "companyClass", label: "Clase de empresa" },
    { value: "economicActivity", label: "Actividad económica" },
    { value: "employedNumber", label: "Número de empleados" },
    { value: "startOperation", label: "Fecha de inicio de operación" },
    { value: "payrollMonth", label: "Valor nómina mes" },
    { value: "contributionPeriod", label: "Primer periodo de aportes" },
]



export const REQUIRED_FORM_STEP2_DOMES = [
    { value: "companyClass", label: "Clase de empresa" },
    { value: "economicActivity", label: "Actividad económica" },
    { value: "employedNumber", label: "Número de empleados" },
    { value: "payrollMonth", label: "Valor nómina mes" },
    { value: "contributionPeriod", label: "Primer periodo de aportes" },
]

export const REQUIRED_FORM_STEP3 = [
    { value: "departamentCompany", label: "Departamento de empresa" },
    { value: "cityCompany", label: "Municipio de empresa" },
    { value: "hoodCompany", label: "Barrio empresa" },
    { value: "addressCompany", label: "Dirección de empresa" },
]

export const REQUIRED_FORM_STEP3_CONTACT = [
    { value: "phoneCompany", label: "Número de teléfono" },
]

export const REQUIRED_FORM_STEP3_ALTERN = [
    { value: "departamentCompanyAlternate", label: "Departamento de empresa alterna" },
    { value: "cityCompanyAlternate", label: "Municipio de empresa alterna" },
    { value: "hoodCompanyAlternate", label: "Barrio empresa alterna" },
    { value: "addressCompanyAlternate", label: "Dirección de empresa alterna" },
]

export const REQUIRED_FORM_STEP4 = [
    { value: "typeId", label: "Tipo de identificación" },
    { value: "numberId", label: "Número de identificación" },
    { value: "birthDate", label: "Fecha de nacimiento" },
    { value: "firstLastname", label: "Primer apellido" },
    { value: "firstName", label: "Primer nombre" },
    { value: "jobBoss", label: "Cargo" },
    { value: "smartPhoneBoss", label: "Celular" },
    { value: "emailJobBoss", label: "Correo electrónico" },
    { value: "sexo", label: "Género" },
]
export const REQUIRED_FORM_STEP1 = [
    { value: "typeIdStaff", label: "Tipo de identificación" },
    { value: "numberIdStaff", label: "Número de identificación" },
    { value: "firstLastnameStaff", label: "Primer apellido" },
    { value: "firstNameStaff", label: "Primer nombre" },
    { value: "jobBossStaff", label: "Cargo" },
    { value: "birthDateStaff", label: "Fecha de nacimiento" },
    { value: "smartPhoneBossStaff", label: "Celular" },
    { value: "emailStaff", label: "Correo electrónico" },
    { value: "sexoStaff", label: "Género" },
]


const JURAMENTO_P5 = [
    "- Toda la información aquí suministrada es verídica y se entenderá presentada bajo la gravedad de juramento",
    "- Mi hogar cumple con las condiciones para ser beneficiario del subsidio familiar de empresas y no estoy(estamos) incurso(s) en las imposibilidades para solicitarlo. ",
    "- Los ingresos familiares de mi hogar no son superiores al equivalente de (4) cuatro salarios mensuales mínimos legales vigentes (SMMLV).",

]

export const AFILIACION_EMPRESAS_FORM = [

    {
        tooltip: "Selecciona el tipo de empleador",
        label: "Tipo de empleador*",
        dataTitle: "Selecciona el tipo de empleador",
        name: "empleadorTypeCompany",
        placeholder: "Tipo de empleador",
        type: "select",
        typeForm: "select",
        value: false,
        options: [
        ],
        disabled: false,
        className: "rs-30"
    },
    {
        tooltip: "Selecciona el tipo de identificación del empleador.",
        label: "Tipo de identificación*",
        name: "typeIdCompanyGes",
        placeholder: "Tipo de identificación empresa",
        type: "select",
        typeForm: "select",
        value: false,
        options: [
        ],
        disabled: false,
        className: "rs-30"
    },
    {
        tooltip: "Digita el número de identificación, sin digito de verificación",
        dataTitle: "Digita el número de identificación, sin digito de verificación",
        label: "Número de identificación*",
        name: "numberIdCompanyGes",
        placeholder: "Número de identificación empresa",
        type: "number",
        typeForm: "number",
        maxLength: 20,
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },

]

export const getDataInicioInscripcionForm = () => {
    return [
        {
            name: "employerDevolucion",
            placeholder: "",
            type: "instruccion",
            typeForm: "instruccion",
            value: false,
            options: [],
            disabled: false,
            className: "rs-100 devolucion",
            hidden: false
        },
        {
            tooltip: "Digita el nombre del empleador (Razon social si es persona juridica y Nombre completo si es persona natural y/o servicio doméstico).",
            dataTitle: "Digita el nombre del empleador (Razon social si es persona juridica y Nombre completo si es persona natural y/o servicio doméstico).",
            label: "Nombre del empleador*",
            name: "employerNameStart",
            placeholder: "Nombre empleador*",
            maxLength: 200,
            type: "textRazon",
            typeForm: "textRazon",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
            label: "Tipo de identificación",
            name: "typeIdCompanyStart",
            placeholder: "Tipo de identificación empresa",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30"
        },
        {
            //tooltip: "Ingresa el número de identificación",
            label: "Número de identificación",
            name: "checkNumberStart",
            placeholder: "Número identificación",
            //minLength: 10,
            maxLength: 20,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico de contacto con el empleador (Respuesta a su solicitud y Usuario para afiliación de trabajadores).",
            dataTitle: "Digita el correo electrónico de contacto con el empleador (Respuesta a su solicitud y Usuario para afiliación de trabajadores).",
            label: "Correo electrónico*",
            name: "emailCompanyStart",
            placeholder: "Correo electrónico",
            maxLength: 250,
            type: "email",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico de contacto con el empleador (debe ser el mismo que digitó anteriormente).",
            dataTitle: "Digita el correo electrónico de contacto con el empleador (debe ser el mismo que digitó anteriormente)",
            label: "Confirma correo electrónico*",
            name: "emailCompanyCheckStart",
            placeholder: "Confirma correo electrónico*",
            type: "text",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el número de trabajadores activos en el Valle del Cauca.",
            label: "Número de empleados*",
            name: "employedNumberStart",
            placeholder: "Número de empleados*",
            maxLength: 9,
            type: "number",
            typeForm: "number",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Indique el codigo CIIU que registra en el RUT en la casilla 46.",
            label: "Actividad económica*",
            name: "economicActivityStart",
            placeholder: "Actividad económica*",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el municipio (más cercano) en el  Valle del Cauca donde laboran sus trabajadores",
            label: "Regional/Sede*",
            name: "sedeRegional",
            placeholder: "Regional/Sede*",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Digita el valor de la nómina mensual por el total de trabajadores causada en el Valle del Cauca.",
            label: "Valor nómina mes*",
            name: "payrollMonthStart",
            placeholder: "Valor nómina mes*",
            maxLength: 17,
            type: "number",
            typeForm: "numberN",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el número de telefóno móvil del empleador",
            label: "Celular empleador*",
            name: "smartPhoneRegistro",
            placeholder: "Teléfono celular empleador*",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },

    ]
}

export const getDataInicioInscripcionFormJuridica = () => {
    return [
        {
            name: "employerDevolucion",
            placeholder: "",
            type: "instruccion",
            typeForm: "instruccion",
            value: false,
            options: [],
            disabled: false,
            className: "rs-100 devolucion",
            hidden: false
        },
        {
            tooltip: "Digita el nombre del empleador (Razon social si es persona juridica y Nombre completo si es persona natural y/o servicio doméstico).",
            dataTitle: "Digita el nombre del empleador (Razon social si es persona juridica y Nombre completo si es persona natural y/o servicio doméstico).",
            label: "Nombre del empleador*",
            name: "employerNameStart",
            placeholder: "Nombre empleador*",
            maxLength: 200,
            type: "textRazon",
            typeForm: "textRazon",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
            label: "Tipo de identificación",
            name: "typeIdCompanyStart",
            placeholder: "Tipo de identificación empresa",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30"
        },
        {
            //tooltip: "Ingresa el número de identificación",
            label: "Número de identificación",
            name: "checkNumberStart",
            placeholder: "Número identificación",
            //minLength: 10,
            maxLength: 20,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico de contacto con el empleador (Respuesta a su solicitud y Usuario para afiliación de trabajadores)",
            dataTitle: "Digita el correo electrónico de contacto con el empleador (Respuesta a su solicitud y Usuario para afiliación de trabajadores).",
            label: "Correo electrónico*",
            name: "emailCompanyStart",
            placeholder: "Correo electrónico",
            maxLength: 250,
            type: "email",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico de contacto con el empleador (debe ser el mismo que digitó anteriormente)",
            dataTitle: "Digita el correo electrónico de contacto con el empleador (debe ser el mismo que digitó anteriormente)",
            label: "Confirma correo electrónico*",
            name: "emailCompanyCheckStart",
            placeholder: "Confirma correo empresa*",
            type: "text",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el número de trabajadores activos en el Valle del Cauca.",
            label: "Número de empleados*",
            name: "employedNumberStart",
            placeholder: "Número de empleados*",
            maxLength: 9,
            type: "number",
            typeForm: "number",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Indique el codigo CIIU que registra en el RUT en la casilla 46.",
            label: "Actividad económica*",
            name: "economicActivityStart",
            placeholder: "Actividad económica*",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el municipio (más cercano) en el  Valle del Cauca donde laboran sus trabajadores",
            label: "Regional/Sede*",
            name: "sedeRegional",
            placeholder: "Regional/Sede*",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Digita el valor de la nómina mensual por el total de trabajadores causada en el Valle del Cauca.",
            label: "Valor nómina mes*",
            name: "payrollMonthStart",
            placeholder: "Valor nómina mes*",
            maxLength: 17,
            type: "number",
            typeForm: "numberN",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el número de telefóno móvil del empleador",
            label: "Celular empleador*",
            name: "smartPhoneRegistro",
            placeholder: "Teléfono celular empleador*",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },

    ]
}

export const getDataEmpleadorForm = () => {
    return [

        {
            label: " ",
            name: "document",
            placeholder: " ",
            type: "spacer",
            typeForm: "spacer",
            value: false,
            options: [],
            disabled: false,
            className: "spacer rs-60"
        },
        {
            // tooltip: "Ingresa el número de registro",
            label: "Número de registro",
            name: "processNumber",
            placeholder: "Número proceso",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30 numProcess",
            hidden: false
        },
        {
            // tooltip: "Ingresa el nombre completo del empleador",
            label: "Nombre del empleador*",
            name: "employerName",
            placeholder: "Nombre empleador*",
            maxLength: 200,
            type: "textRazon",
            typeForm: "textRazon",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            // tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
            label: "Tipo de identificación",
            name: "typeIdCompany",
            placeholder: "Tipo de identificación empresa",
            type: "select",
            typeForm: "select",
            value: false,
            options: [
            ],
            disabled: true,
            className: "rs-30"
        },
        {
            //tooltip: "Ingresa el número de identificación",
            label: "Número de identificación",
            name: "checkNumber",
            placeholder: "Número identificación",
            //minLength: 10,
            maxLength: 20,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el digito de verificación",
            label: "Digito de verificación",
            name: "digitNumber",
            placeholder: "Digito verificación",
            maxLength: 1,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Selecciona como corresponda:  Mixta: Si la empresa funciona con aportes estatales y de capital privado.  Pública: Si la empresa funciona con fondos oficales del estado.     Privada: Si la empresa funciona con patrimonio particular. ",
            label: "Clase de empresa*",
            name: "companyClass",
            placeholder: "Clase empresa*",
            type: "select",
            typeForm: "select",
            value: false,
            options: [
            ],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Indique el codigo CIIU que registra en el RUT en la casilla 46.",
            label: "Actividad económica*",
            name: "economicActivity",
            placeholder: "Actividad económica*",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30"
        },
        {
            // tooltip: "Digita el correo electrónico de contacto con el empleador (Respuesta a su solicitud y Usuario para afiliación de trabajadores).",
            label: "Correo electrónico*",
            name: "emailCompany",
            placeholder: "Correo electrónico",
            maxLength: 250,
            type: "text",
            typeForm: "email",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        // {
        //     tooltip: "Confirma el Correo de la empresa",
        //     label: "Confirma Correo*",
        //     name: "emailCompanyCheck",
        //     placeholder: "Confirma correo empresa*",
        //     type: "text",
        //     typeForm: "email",
        //     value: false,
        //     options: [],
        //     disabled: false,
        //     className: "rs-30",
        //     hidden: false
        // },
        {
            //tooltip: "Digita el número de trabajadores activos en el Valle del Cauca.",
            label: "Número de empleados*",
            name: "employedNumber",
            placeholder: "Número de empleados*",
            maxLength: 9,
            type: "number",
            typeForm: "number",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
            label: "Fecha de inicio de operación*",
            name: "startOperation",
            placeholder: " ",
            type: "date",
            typeForm: "date",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Digita el valor de la nómina mensual causada en el Valle del Cauca.",
            label: "Valor nómina mes*",
            name: "payrollMonth",
            placeholder: "Valor nómina mes*",
            maxLength: 17,
            type: "number",
            typeForm: "numberN",
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita en números mes y año de la primera nómina por la que pagará aportes a Comfenalco Valle",
            label: "Primer periodo de aportes*",
            name: "contributionPeriod",
            placeholder: " ",
            type: "dateMo",
            typeForm: "dateMo",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        }

    ]
}

export const getUbicacionEmpleador = (modalDireccion) => {
    return [
        {
            tooltip: "Digita o Selecciona el Departamento donde se encuentra ubicado el empleador.",
            label: "Departamento*",
            name: "departamentCompany",
            placeholder: "Departamento*",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Digita o Selecciona el Municipio donde se encuentra ubicado el empleador",
            label: "Municipio*",
            name: "cityCompany",
            placeholder: "Municipio*",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Digita o Selecciona el Barrio donde se encuentra ubicado el empleador",
            label: "Barrio*",
            name: "hoodCompany",
            placeholder: "Barrio*",
            maxLength: 250,
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita la direccion de correspondencia del empleador",
            label: "Dirección*",
            name: "addressCompany",
            placeholder: "Dirección*",
            hint: modalDireccion,
            type: "dire",
            maxLength: 50,
            typeForm: "dire",
            value: false,
            options: [{ modalDireccion }],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
    ]
}

export const getUbicacionEmpleadorAltern = (modalDireccion) => {
    return [
        {
            tooltip: "Digita o Selecciona el Departamento en donde tiene sedes como empleador, puede ser la sede principal o sucursales.",
            label: "Departamento",
            name: "departamentCompanyAlternate",
            placeholder: "Departamento",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            //tooltip: "Seleccione el municipio de la empresa",
            label: "Municipio",
            name: "cityCompanyAlternate",
            placeholder: "Municipio",
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            // tooltip: "Ingresa el barrio de la empresa",
            label: "Barrio",
            name: "hoodCompanyAlternate",
            placeholder: "Barrio",
            maxLength: 250,
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            // tooltip: "Ingresa la dirección de la empresa",
            label: "Dirección",
            name: "addressCompanyAlternate",
            placeholder: "Dirección",
            type: "dire",
            typeForm: "dire",
            maxLength: 50,
            value: false,
            options: [{ modalDireccion }],
            disabled: false,
            className: "rs-30",
            hidden: false
        },

    ]
}
export const getUbicacionEmpleadorContact = () => {
    return [
        {
            // tooltip: "Ingresa el teléfono fijo de la empresa",
            label: "Teléfono fijo",
            name: "phoneCompany",
            placeholder: "Teléfono fijo empresa",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Digita el teléfono móvil del empleador",
            label: "Teléfono celular*",
            name: "smartPhoneCompany",
            placeholder: "Teléfono celular empresa*",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: true,
            className: "rs-30",
            hidden: false
        },
        {
            // tooltip: "Ingresa la dirección electronica de la empresa",
            label: "Pagina web empresa",
            name: "webSite",
            placeholder: "Pagina web empresa",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },

    ]
}
export const INFORMACION_REPRESENTANTE_FORM = [

    {
        //tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
        label: "",
        name: "rnecBoxRepresentante",
        placeholder: "",
        type: "rnecBox",
        typeForm: "rnecBox",
        value: false,
        options: [],
        disabled: false,
        className: "rs-100 rnecBoxValid"
    },
    {
        tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
        label: "Tipo de identificación",
        name: "typeId",
        placeholder: "Tipo de identificación",
        type: "select",
        typeForm: "select",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30"
    },
    {
        tooltip: "Selecciona el número de identificacion",
        label: "Número de identificación",
        name: "numberId",
        placeholder: "Número de identificación",
        type: "number",
        typeForm: "number",
        //minLength: 10,
        maxLength: 20,
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        tooltip: "Ingresa la fecha de nacimiento del representante legal",
        label: "Fecha de nacimiento",
        name: "birthDate",
        placeholder: "",
        maxLength: 250,
        type: "date",
        typeForm: "date",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        //tooltip: "Ingresa el primer apellido del representante legal",
        label: "Primer apellido",
        name: "firstLastname",
        placeholder: "Primer apellido",
        maxLength: 250,
        type: "textNames",
        typeForm: "textNames",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        //tooltip: "Ingresa el segundo apellido del representante legal",
        label: "Segundo apellido",
        name: "secondLastname",
        placeholder: "Segundo apellido",
        maxLength: 250,
        type: "textNames",
        typeForm: "textNames",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        //tooltip: "Ingresa el primer nombre del representante legal",
        label: "Primer nombre",
        name: "firstName",
        placeholder: "Primer nombre",
        maxLength: 250,
        type: "textNames",
        typeForm: "textNames",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        //tooltip: "Ingresa el segundo nombre del representante legal",
        label: "Segundo nombre",
        name: "secondName",
        placeholder: "Segundo nombre",
        maxLength: 250,
        type: "text",
        typeForm: "text",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        tooltip: "Seleccione el sexo del representante legal de la empresa",
        label: "Género",
        name: "sexo",
        placeholder: "Género",
        type: "select",
        typeForm: "select",
        value: false,
        options: [{ label: "Masculino", value: "M" }, { label: "Femenino", value: "F" }],
        disabled: false,
        className: "rs-30"
    },
    {
        tooltip: "Ingresa el teléfono movil del representante legal",
        label: "Celular*",
        name: "smartPhoneBoss",
        placeholder: "Celular*",
        type: "number",
        typeForm: "number",
        maxLength: 10,
        //minLength: 10,
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        tooltip: "Selecciona el cargo que ocupa el representante legal",
        label: "Cargo",
        name: "jobBoss",
        placeholder: "Cargo representante legal",
        maxLength: 250,
        type: "autocomplete",
        typeForm: "autocomplete",
        value: false,
        options: [
        ],
        disabled: false,
        className: "rs-30",
        hidden: false
    },
    {
        tooltip: "Ingresa el Correo del representante legal",
        label: "Correo electrónico*",
        name: "emailJobBoss",
        placeholder: "Correo electrónico",
        maxLength: 250,
        type: "email",
        typeForm: "email",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30",
        hidden: false
    },

]

export const DIRECCIONES_FORM = [

    {
        //tooltip: "Seleccione el tipo de nomenclatura de la dirección",
        label: "Nombre de vía",
        name: "interseptionType",
        placeholder: "",
        type: "select",
        typeForm: "select",
        value: false,
        options: [],
        disabled: false,
        className: "rs-15"
    },
    {
        //tooltip: "Seleccione número de la nomemclatura",
        label: "# via",
        name: "interseptionNumber",
        placeholder: "",
        type: "textCharacter",
        typeForm: "textCharacter",
        value: false,
        options: [],
        disabled: false,
        className: "rs-10"
    },
    {
        // tooltip: "Simbolo de separacion nomenclatura",
        label: "#",
        name: "simboloNumeral",
        placeholder: "#",
        type: "text",
        typeForm: "text",
        value: "#",
        options: [],
        disabled: true,
        className: "rs-5 simbolo"
    },
    {
        // tooltip: "Seleccione la intercepción de la nomemclatura",
        label: "|",
        name: "interseptionNumberTwo",
        placeholder: "",
        type: "textCharacter",
        typeForm: "textCharacter",
        value: false,
        options: [],
        disabled: false,
        className: "rs-10 noSimbolo"
    },
    {
        // tooltip: "Simbolo de separacción intercepción",
        label: "|",
        name: "simboloGuion",
        placeholder: "-",
        type: "label",
        typeForm: "text",
        value: "-",
        options: [],
        disabled: true,
        className: "rs-5 simbolo"
    }, {
        // tooltip: "Seleccione la intercepción de la nomemclatura",
        label: "|",
        name: "interseptionNumberThree",
        placeholder: "",
        type: "textCharacter",
        typeForm: "textCharacter",
        value: false,
        options: [],
        disabled: false,
        className: "rs-10 noSimbolo"
    },
    {
        //tooltip: "Seleccione la direccion de la nomenclatura",
        label: "Información adicional",
        name: "houseType",
        placeholder: "",
        type: "select",
        typeForm: "select",
        value: false,
        options: [],
        disabled: false,
        className: "rs-20"
    },
    {
        //  tooltip: "Se refiere al complemento de la dirección",
        label: "|",
        name: "houseComplemento",
        placeholder: "",
        maxLength: 40,
        type: "onlyText",
        typeForm: "onlyText",
        value: false,
        options: [],
        disabled: false,
        className: "rs-20 noSimbolo",
        hidden: false
    },
]

export const DIRECCIONES_FORM_CORREGIMIENTO = [

    {
        //tooltip: "Seleccione el tipo de nomenclatura de la dirección",
        label: "Número via",
        name: "interseptionType",
        placeholder: "",
        type: "select",
        typeForm: "select",
        value: false,
        options: [],
        disabled: false,
        className: "rs-20"
    },
    {
        //tooltip: "Seleccione número de la nomemclatura",
        label: "|",
        name: "interseptionNumber",
        placeholder: "",
        type: "onlyText",
        typeForm: "onlyText",
        value: false,
        options: [],
        disabled: false,
        className: "rs-15 noSimbolo"
    },
    {
        //tooltip: "Seleccione la direccion de la nomenclatura",
        label: "Información adicional",
        name: "houseTypeCor",
        placeholder: "",
        type: "select",
        typeForm: "select",
        value: "VDA",
        options: [{ label: "VEREDA", value: "VDA" }],
        disabled: true,
        className: "rs-20"
    },
    {
        //  tooltip: "Se refiere al complemento de la dirección",
        label: "|",
        name: "houseComplemento",
        placeholder: "",
        maxLength: 40,
        type: "onlyText",
        typeForm: "onlyText",
        value: false,
        options: [],
        disabled: false,
        className: "rs-30 noSimbolo",
        hidden: false
    },
]

export const JURAMENTO_PARTES = [

    {

        name: "document",
        placeholder: " ",
        type: "cardJura",
        typeForm: "cardJura",
        value: false,
        disabled: false,
        options: JURAMENTO_P5,
        className: "spacerJuramento rs-100"
    },
    {
        label: "Aceptar Juramento*",
        name: "juramentoCheck",
        placeholder: "Aceptar Juramento*",
        type: "checkbox",
        typeForm: "checkbox",
        value: false,
        disabled: false,
        className: "AceptarJuramento rs-50"
    },


]

export const JURAMENTO_ACEP = [
    {
        label: JURAMENTO_TITLE,
        name: "juramentoPartes",
        type: "section",
        typeForm: "section",
        className: "rs-100 juramentoPartes",
        fields: JURAMENTO_PARTES
    }
]


export const getAfiliacionCompanyForm = () => {
    const AFILIACION_EMPRESAS = [
        {
            label: AFILIACION_EMPRESAS_TITLE,
            name: "afiliacionEmpresas",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: AFILIACION_EMPRESAS_FORM
        }
    ]
    return AFILIACION_EMPRESAS;
}
export const getStep0Form = () => {
    return [
        {
            label: DATOS_INICIO_TITLE,
            name: "datosinicio",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getDataInicioInscripcionForm()
        }
    ];
}

export const getStep0FormJuridico = () => {
    return [
        {
            label: DATOS_INICIO_TITLE,
            name: "datosinicio",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getDataInicioInscripcionFormJuridica()
        }
    ];
}

export const getStep2Form = () => {
    const INFORMACION_EMPLEADOR = [
        {
            label: DATOS_EMPLEADOR_TITLE,
            name: "datosempleador",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getDataEmpleadorForm()
        },
        {
            label: "",
            name: "ubicacionempleadorask",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    tooltip: "Si actualmente está afiliado a una Caja de Compensación como persona dependiente, independiente o pensionado, esto no afectará su proceso de afiliación como Empleador (Natural/Jurídico/Empleador del servicio doméstico).",
                    label: " Estuvo o está afiliado como empleador (Natural/Jurídico/Empleador del servicio doméstico), a una Caja de Compensación en Valle del Cauca?*",
                    name: "empleadorCajaAsk",
                    placeholder: "Estuvo afiliado como empleador?*",
                    type: "radio2",
                    typeForm: "radio2",
                    value: false,
                    options: [
                        { label: 'Si', value: '1', className: "radioSi", },
                        { label: 'No', value: '2', className: "radioNo", },
                    ],
                    disabled: false,
                    className: "form-control rs-60"
                },
                {
                    tooltip: "Selecciona la caja de compensación en la que está o estuvo afiliado como empleador",
                    label: "Nombre Caja anterior*",
                    name: "empleadorCajaRta",
                    placeholder: "Nombre Caja anterior*",
                    type: "select",
                    typeForm: "select",
                    options: [
                        { label: "Comfenalco Valle", value: "Comfenalco valle" },
                        { label: "Comfandi", value: "Comfandi" },
                    ],
                    value: false,
                    disabled: true,
                    className: "form-control rs-40"
                },
            ]
        },
    ]
    return INFORMACION_EMPLEADOR;
}
export const getStep2FormDomestico = () => {
    const INFORMACION_EMPLEADOR = [
        {
            label: DATOS_EMPLEADOR_TITLE,
            name: "datosempleador",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [

                {
                    label: " ",
                    name: "document",
                    placeholder: " ",
                    type: "spacer",
                    typeForm: "spacer",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "spacer rs-60"
                },
                {
                    //tooltip: "Ingresa el número de registro",
                    label: "Número de registro",
                    name: "processNumber",
                    placeholder: "Número proceso",
                    maxLength: 250,
                    type: "text",
                    typeForm: "text",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30 numProcess",
                    hidden: false
                },
                {
                    // tooltip: "Ingresa el nombre completo del empleador",
                    label: "Nombre del empleador*",
                    name: "employerName",
                    placeholder: "Nombre empleador*",
                    maxLength: 250,
                    type: "text",
                    typeForm: "text",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30",
                    hidden: false
                },
                {
                    // tooltip: "Seleccione el tipo de identificación del representante legal de la empresa",
                    label: "Tipo de identificación",
                    name: "typeIdCompany",
                    placeholder: "Tipo de identificación empresa",
                    type: "select",
                    typeForm: "select",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30"
                },
                {
                    //tooltip: "Ingresa el número de identificación",
                    label: "Número de identificación",
                    name: "checkNumber",
                    placeholder: "Número identificación",
                    //minLength: 10,
                    maxLength: 20,
                    type: "text",
                    typeForm: "text",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30",
                    hidden: false
                },
                {
                    tooltip: "Selecciona como corresponda:  Mixta: Si la empresa funciona con aportes estatales y de capital privado.  Pública: Si la empresa funciona con fondos oficales del estado.     Privada: Si la empresa funciona con patrimonio particular. ",
                    label: "Clase de empresa*",
                    name: "companyClass",
                    placeholder: "Clase empresa*",
                    type: "select",
                    typeForm: "select",
                    value: false,
                    options: [
                    ],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    tooltip: "Indique el codigo CIIU que registra en el RUT en la casilla 46.",
                    label: "Actividad económica*",
                    name: "economicActivity",
                    placeholder: "Actividad económica*",
                    type: "autocomplete",
                    typeForm: "autocomplete",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30"
                },
                {
                    //tooltip: "Ingresa el Correo de la empresa",
                    label: "Correo electrónico*",
                    name: "emailCompany",
                    placeholder: "Correo electrónico",
                    maxLength: 250,
                    type: "text",
                    typeForm: "email",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30",
                    hidden: false
                },

                {
                    //tooltip: "Ingresa el número de empleados",
                    label: "Número de empleados*",
                    name: "employedNumber",
                    placeholder: "Número de empleados*",
                    maxLength: 9,
                    type: "number",
                    typeForm: "number",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30",
                    hidden: false
                },
                {
                    tooltip: "Digita el valor de la nómina mensual causada en el Valle del Cauca.",
                    label: "Valor nómina mes*",
                    name: "payrollMonth",
                    placeholder: "Valor nómina mes*",
                    maxLength: 17,
                    type: "number",
                    typeForm: "numberN",
                    value: false,
                    options: [],
                    disabled: true,
                    className: "rs-30",
                    hidden: false
                },
                {
                    tooltip: "Digita en números mes y año de la primera nómina por la que pagará aportes a Comfenalco Valle",
                    label: "Primer periodo de aportes*",
                    name: "contributionPeriod",
                    placeholder: " ",
                    type: "dateMo",
                    typeForm: "dateMo",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                }

            ]
        },
        {
            label: "",
            name: "ubicacionempleadorask",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    tooltip: "Si actualmente está afiliado a una Caja de Compensación como persona dependiente, independiente o pensionado, esto no afectará su proceso de afiliación como Empleador (Natural/Jurídico/Empleador del servicio doméstico).",
                    label: " Estuvo o está afiliado como empleador (Natural/Jurídico/Empleador del servicio doméstico), a una Caja de Compensación en Valle del Cauca?*",
                    name: "empleadorCajaAsk",
                    placeholder: "Estuvo afiliado como empleador?*",
                    type: "radio2",
                    typeForm: "radio2",
                    value: false,
                    options: [
                        { label: 'Si', value: '1', className: "radioSi", },
                        { label: 'No', value: '2', className: "radioNo", },
                    ],
                    disabled: false,
                    className: "form-control rs-60"
                },
                {
                    tooltip: "Selecciona la caja de compensación en la que está o estuvo afiliado como empleador",
                    label: "Nombre Caja anterior*",
                    name: "empleadorCajaRta",
                    placeholder: "Nombre Caja anterior*",
                    type: "select",
                    typeForm: "select",
                    options: [
                        { label: "Comfenalco Valle", value: "Comfenalco valle" },
                        { label: "Comfandi", value: "Comfandi" },
                    ],
                    value: false,
                    disabled: true,
                    className: "form-control rs-40"
                },
            ]
        },
    ]
    return INFORMACION_EMPLEADOR;
}

export const getModalForm = () => {
    return [
        {
            label: "Datos dirección",
            name: "datosdireccion",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: DIRECCIONES_FORM
        }
    ]
}

export const getModalFormDir = () => {
    return [
        {
            label: "Datos dirección",
            name: "datosdireccion",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: DIRECCIONES_FORM_CORREGIMIENTO
        }
    ]
}

export const getModalNumProcesos = () => {
    return [
        {
            label: "Proceso pendiente",
            name: "datosNumProcess",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    placeholder: `Se ha detectado que tiene un proceso de inscripción pendiente por finalizar, por favor ingrese el número de registro que fue enviado a su correo electrónico para continuar.`,
                    name: "instruccion",
                    type: "information",
                    typeForm: "information",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-100 instruccion2"
                },
                {
                    //tooltip: "Seleccione número de la nomemclatura",
                    label: "Número de registro*",
                    name: "processNumber",
                    placeholder: "Ingrese el número de proceso*",
                    type: "text",
                    typeForm: "text",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-100"
                },
            ]
        }
    ]
}

export const getStep3Form = (modalDireccion) => {
    const UBICACION_EMPLEADOR = [
        {
            label: UBICACION_EMPLEADOR_TITLE,
            name: "ubicacionempleador",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getUbicacionEmpleador(modalDireccion)
        },
        {
            label: UBICACION_EMPLEADOR_TITLE_ALTERN,
            name: "ubicacionempleadoraltern",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getUbicacionEmpleadorAltern(modalDireccion)
        },
        {
            label: "",
            name: "ubicacionempleadorcontact",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getUbicacionEmpleadorContact()
        },


    ]
    return UBICACION_EMPLEADOR;
}

export const getStep4Form = () => {
    const INFORMACION_REPRESENTANTE = [
        {
            label: DATOS_REPRESENTANTE_TITLE,
            name: "datosrepresentante",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: INFORMACION_REPRESENTANTE_FORM
        },

    ]
    return INFORMACION_REPRESENTANTE;
}

export const getStep1Form = (gestionPersonalAdmin) => {
    const INFORMACION_PERSONAL = [
        {
            label: DATOS_PERSONAL_TITLE,
            name: "datospersonaladmin",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getPersonalAdmin(gestionPersonalAdmin),
        },
        {
            name: "tablePersonal",
            type: "table3",
            typeForm: "table3",
            value: false,
            disabled: false,
            row: gestionPersonalAdmin,
            className: "rs-100",
            rows: ["RNEC", "TIPO IDENTIFICACION", "N° IDENTIFICACION", "PRIMER APELLIDO", "SEGUNDO APELLIDO", "PRIMER NOMBRE", "SEGUNDO NOMBRE", "CARGO", "CORREO"],
            options: [],
            hidden: false,

        },
    ]
    return INFORMACION_PERSONAL;
}

export const getStep1FormBandeja = (gestionPersonalAdmin) => {
    const INFORMACION_PERSONAL = [
        {
            label: DATOS_PERSONAL_TITLE,
            name: "datospersonaladmin",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getPersonalAdminBandeja(gestionPersonalAdmin),
        },
        {
            name: "tablePersonal",
            type: "table3",
            typeForm: "table3",
            value: false,
            disabled: false,
            row: gestionPersonalAdmin,
            className: "rs-100",
            rows: ["RNEC", "TIPO IDENTIFICACION", "N° IDENTIFICACION", "PRIMER APELLIDO", "SEGUNDO APELLIDO", "PRIMER NOMBRE", "SEGUNDO NOMBRE", "CARGO", "CORREO"],
            options: [],
            hidden: false,

        },
    ]
    return INFORMACION_PERSONAL;
}

export const getPersonalAdmin = (handleClean) => {
    return [

        {
            tooltip: "Selecciona el tipo de identificación del contacto o del personal administrativo del empleador.",
            label: "Tipo de identificación",
            name: "typeIdStaff",
            placeholder: "Tipo de identificación",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el tipo de identificación del contacto o personal administrativo del empleador.",
            label: "Número de identificación",
            name: "numberIdStaff",
            placeholder: "Número de identificación",
            type: "number",
            typeForm: "number",
            //minLength: 10,
            maxLength: 20,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Selecciona el día, mes y año de nacimiento del contacto o personal administrativo del empleador.",
            label: "Fecha de nacimiento*",
            name: "birthDateStaff",
            placeholder: "",
            maxLength: 250,
            type: "date",
            typeForm: "date",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el primer apellido del personal administrativo y/o directivo",
            label: "Primer apellido*",
            name: "firstLastnameStaff",
            placeholder: "Primer apellido*",
            maxLength: 250,
            type: "textNames",
            typeForm: "textNames",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            // tooltip: "Ingresa el segundo apellido del personal administrativo y/o directivo",
            label: "Segundo apellido",
            name: "secondLastnameStaff",
            placeholder: "Segundo apellido",
            maxLength: 250,
            type: "textNames",
            typeForm: "textNames",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el primer nombre del personal administrativo y/o directivo",
            label: "Primer nombre*",
            name: "firstNameStaff",
            placeholder: "Primer nombre*",
            maxLength: 250,
            type: "textNames",
            typeForm: "textNames",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el segundo nombre del personal administrativo y/o directivo",
            label: "Segundo nombre",
            name: "secondNameStaff",
            placeholder: "Segundo nombre",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Selecciona el sexo como figura en documento de identidad.",
            label: "Género*",
            name: "sexoStaff",
            placeholder: "Género",
            type: "select",
            typeForm: "select",
            value: false,
            options: [{ label: "Masculino", value: "M" }, { label: "Femenino", value: "F" }],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el nombre del cargo mas afín con las funciones que desempeña.",
            label: "Cargo*",
            name: "jobBossStaff",
            placeholder: "Cargo*",
            maxLength: 250,
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digíta el número teléfono movil.",
            label: "Celular*",
            name: "smartPhoneBossStaff",
            placeholder: "Celular*",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico del contacto o personal adiministativo del empleador",
            dataTitle: "Digita el correo electrónico del contacto o personal adiministativo del empleador",
            label: "Correo electrónico*",
            name: "emailStaff",
            placeholder: "Correo electrónico*",
            type: "email",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            label: " ",
            name: "document",
            placeholder: " ",
            type: "spacer",
            typeForm: "spacer",
            value: false,
            options: [],
            disabled: false,
            className: "spacer rs-70"
        },
        {
            name: "cleanDirectivo",
            placeholder: "Limpiar",
            type: "buttonX",
            typeForm: "buttonX",
            primary: true,
            value: false,
            options: [],
            hidden: false,
            disabled: false,
            className: "rs-10",
            onClick: handleClean,
        },
        {
            name: "saveDirectivo",
            placeholder: "Adicionar",
            type: "buttonX",
            typeForm: "buttonX",
            primary: true,
            value: false,
            options: [],
            hidden: false,
            disabled: false,
            className: "rs-10",
            onClick: handleClean,
        }
    ];
}

export const getPersonalAdminBandeja = (handleClean) => {
    return [

        {
            tooltip: "Selecciona el tipo de identificación del contacto o del personal administrativo del empleador.",
            label: "Tipo de identificación",
            name: "typeIdStaff",
            placeholder: "Tipo de identificación",
            type: "select",
            typeForm: "select",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el tipo de identificación del contacto o personal administrativo del empleador.",
            label: "Número de identificación",
            name: "numberIdStaff",
            placeholder: "Número de identificación",
            type: "number",
            typeForm: "number",
            //minLength: 10,
            maxLength: 20,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Selecciona el día, mes y año de nacimiento del contacto o personal administrativo del empleador.",
            label: "Fecha de nacimiento*",
            name: "birthDateStaff",
            placeholder: "",
            maxLength: 250,
            type: "date",
            typeForm: "date",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el primer apellido del personal administrativo y/o directivo",
            label: "Primer apellido*",
            name: "firstLastnameStaff",
            placeholder: "Primer apellido*",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            // tooltip: "Ingresa el segundo apellido del personal administrativo y/o directivo",
            label: "Segundo apellido",
            name: "secondLastnameStaff",
            placeholder: "Segundo apellido",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el primer nombre del personal administrativo y/o directivo",
            label: "Primer nombre*",
            name: "firstNameStaff",
            placeholder: "Primer nombre*",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            //tooltip: "Ingresa el segundo nombre del personal administrativo y/o directivo",
            label: "Segundo nombre",
            name: "secondNameStaff",
            placeholder: "Segundo nombre",
            maxLength: 250,
            type: "text",
            typeForm: "text",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Selecciona el sexo como figura en documento de identidad.",
            label: "Género*",
            name: "sexoStaff",
            placeholder: "Género",
            type: "select",
            typeForm: "select",
            value: false,
            options: [{ label: "Masculino", value: "M" }, { label: "Femenino", value: "F" }],
            disabled: false,
            className: "rs-30"
        },
        {
            tooltip: "Selecciona el nombre del cargo mas afín con las funciones que desempeña.",
            label: "Cargo*",
            name: "jobBossStaff",
            placeholder: "Cargo*",
            maxLength: 250,
            type: "autocomplete",
            typeForm: "autocomplete",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digíta el número teléfono movil.",
            label: "Celular*",
            name: "smartPhoneBossStaff",
            placeholder: "Celular*",
            type: "number",
            typeForm: "number",
            maxLength: 10,
            //minLength: 10,
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            tooltip: "Digita el correo electrónico del contacto o personal adiministativo del empleador",
            dataTitle: "Digita el correo electrónico del contacto o personal adiministativo del empleador",
            label: "Correo electrónico*",
            name: "emailStaff",
            placeholder: "Correo electrónico*",
            type: "email",
            typeForm: "email",
            value: false,
            options: [],
            disabled: false,
            className: "rs-30",
            hidden: false
        },
        {
            label: " ",
            name: "document",
            placeholder: " ",
            type: "spacer",
            typeForm: "spacer",
            value: false,
            options: [],
            disabled: false,
            className: "spacer rs-70"
        },
        {
            name: "saveDirectivo",
            placeholder: "Actualizar",
            type: "buttonX",
            typeForm: "buttonX",
            primary: true,
            value: false,
            options: [],
            hidden: false,
            disabled: false,
            className: "rs-10",
            onClick: handleClean,
        }
    ];
}

export const getStep5Form = (handleDownload) => {
    const INFORMACION_EMPLEADOR = [
        {

            name: "datosempleador",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: getTableAnexosForm(handleDownload)
        }
    ]
    return INFORMACION_EMPLEADOR;
}

export const getStep5FormDome = (handleDownload) => {
    const INFORMACION_EMPLEADOR = [
        {

            name: "datosempleador",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    placeholder: "Sr. usuario, recuerde que todos los documentos anexos deben estar escaneados en formato PDF o Imagen (JPG,JPEG, PNG) con un tamaño máximo de 2 MB.$Nota: El anexo Fotocopia Cedula, corresponde a la del representante legal o la del empleador domestico.",
                    name: "instruccion",
                    type: "label",
                    typeForm: "label",
                    value: false,
                    disable: false,
                    className: "rs-100 instruccion"
                },
                {
                    name: "tableOfAnexos",
                    type: "tableAnexos",
                    typeForm: "tableAnexos",
                    value: false,
                    disabled: false,
                    className: "rs-100",
                    rows: ["DOCUMENTO", "OBLIGATORIO", "ARCHIVO", "ACCION"],
                    options: [
                    ],
                    hidden: false,

                },
            ]
        }
    ]
    return INFORMACION_EMPLEADOR;
}

export const getTableAnexosForm = (handleDownload) => {
    return [
        {
            placeholder: "Sr. usuario, recuerde que todos los documentos anexos deben estar escaneados en formato PDF o Imagen (JPG,JPEG, PNG) con un tamaño máximo de 2 MB.$Nota: El anexo Fotocopia Cedula, corresponde a la del representante legal o la del empleador domestico.",
            name: "instruccion",
            type: "label",
            typeForm: "label",
            value: false,
            disable: false,
            className: "rs-100 instruccion"
        },
        {
            name: "workersRelation",
            placeholder: "Relacion de trabajadores",
            type: "buttonDownload",
            typeForm: "buttonDownload",
            primary: true,
            value: false,
            options: [],
            hidden: false,
            disabled: false,
            className: "rs-20",
            onClick: handleDownload,
        },
        {
            name: "tableOfAnexos",
            type: "tableAnexos",
            typeForm: "tableAnexos",
            value: false,
            disabled: false,
            className: "rs-100",
            rows: ["DOCUMENTO", "OBLIGATORIO", "ARCHIVO", "ACCION"],
            options: [
            ],
            hidden: false,

        },
    ]
}

//___________

export const getSubmitButtons = (handlerBack, handleBorrador, handleFinal) => {
    return [
        {
            label: "Volver",
            className: "auth-btn-cancel",
            action: false,
            style: "secondary",
            onClick: handlerBack

        },
        {
            label: "Finalizar",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleFinal
        }
    ]
}

export const getSubmitButtonss = (handleratras, handleNext) => {
    return [
        {
            label: "Atras",
            className: "auth-btn-cancel",
            action: false,
            primary: false,
            style: "secondary",
            onClick: handleratras

        },
        {
            label: "Siguiente",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleNext,

        },

    ]
}

export const getAfiliacionButtons = (handleNext) => {
    return [

        {
            label: "Continuar",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleNext,

        }
    ]
}

export const getInitButtons = (handleNext) => {
    return [

        {
            label: "Siguiente",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleNext,

        }
    ]
}

export const getAddCancel = (handleClean, handleAdd) => {
    return [
        {
            label: "Agregar",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleAdd,

        }, {
            label: "Cancelar",
            className: "auth-btn-cancel",
            action: false,
            primary: false,
            style: "secondary",
            onClick: handleClean

        }
    ]
}

export const getAddSend = (handleClean, handleAdd) => {
    return [
        {
            label: "Enviar",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleAdd,

        }, {
            label: "Cancelar",
            className: "auth-btn-cancel",
            action: false,
            primary: false,
            style: "secondary",
            onClick: handleClean

        }
    ]
}

export const getModalButtons = (handlerBack, handleFinal) => {
    return [
        {
            label: "Volver",
            className: "auth-btn-cancel",
            action: false,
            style: "secondary",
            onClick: handlerBack

        },
        {
            label: "Finalizar",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
        }
    ]
}